/* assets/nb-buy-now.js
   Boton "Comprar ahora": agrega el producto/variante seleccionada al carrito via
   /cart/add.js (mismo formulario real de "Agregar al carrito", misma logica de
   variantes/cantidad) y, si funciona, redirige directo a /checkout. No reemplaza
   ni cambia la logica de metodos de pago, promociones o el carrito: solo salta
   directo al checkout despues de un agregado real. Agregado septiembre 2026.

   Tambien mantiene sincronizado el precio mostrado en la etiqueta del boton
   ("Comprar ahora — $X") con el tamaño/variante que el visitante tenga
   seleccionado, reutilizando el evento variantChange que ya dispara el tema
   (assets/product-info.js) cada vez que termina de actualizar el precio en
   pantalla — asi el texto del boton siempre coincide exactamente con el precio
   ya formateado que se ve en la ficha de producto. Agregado septiembre 2026.
*/
document.addEventListener('click', function (event) {
  var button = event.target.closest('[data-nb-buy-now]');
  if (!button || button.disabled) return;

  var formId = button.getAttribute('data-form');
  var form = formId ? document.getElementById(formId) : null;
  if (!form) return;

  event.preventDefault();

  var label = button.querySelector('[data-nb-buy-now-label]');
  var originalText = label ? label.textContent : null;
  button.disabled = true;
  if (label) label.textContent = 'Agregando…';

  var formData = new FormData(form);
  var cartAddUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
    ? window.Shopify.routes.root
    : '/') + 'cart/add.js';

  fetch(cartAddUrl, {
    method: 'POST',
    headers: { Accept: 'application/json' },
    body: formData
  })
    .then(function (response) {
      if (!response.ok) {
        return response.json().then(function (err) {
          throw err;
        });
      }
      window.location.href = '/checkout';
    })
    .catch(function () {
      button.disabled = false;
      if (label && originalText) label.textContent = originalText;
    });
});

document.addEventListener('DOMContentLoaded', function () {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined' || !PUB_SUB_EVENTS.variantChange) {
    return;
  }

  function currentPriceText(sectionId) {
    var wrapper = document.getElementById('price-' + sectionId);
    if (!wrapper) return null;
    var priceBlock = wrapper.querySelector('.price');
    if (!priceBlock) return null;
    var onSale = priceBlock.classList.contains('price--on-sale');
    var priceItem = onSale
      ? priceBlock.querySelector('.price__sale .price-item--sale')
      : priceBlock.querySelector('.price__regular .price-item--regular');
    return priceItem ? priceItem.textContent.trim() : null;
  }

  subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
    var sectionId = event && event.data && event.data.sectionId;
    if (!sectionId) return;

    var button = document.querySelector(
      '[data-nb-buy-now][data-nb-price-section="' + sectionId + '"]'
    );
    var label = button ? button.querySelector('[data-nb-buy-now-label]') : null;
    if (!label) return;

    var priceText = currentPriceText(sectionId);
    if (priceText) {
      label.textContent = 'Comprar ahora — ' + priceText;
    }
  });
});
